import { HttpStatusCode } from "../lib/HttpStatusCode";
import { SecKy } from "../lib/SecKy";

const endpoint = "/api/surveys";
function makeQuery(page, size, dateFrom, dateTo, dateFilter, search, withAnswersOnly, satisfactionFilter) {
  var query = "";

  if (page)
    query += '&page=' + page;  

  if (size)
    query += '&size=' + size; 

  if (dateFrom)
    query += '&dateFrom=' + dateFrom;
  
  if (dateTo)
    query += '&dateTo=' + dateTo;
  
    if (dateFilter)
    query += '&dateFilter=' + dateFilter;

  if (search)
    query += '&search=' + search;

  if (withAnswersOnly)
    query += '&withAnswersOnly=' + !!withAnswersOnly;
    
  if (satisfactionFilter)
    query += '&satisfactionFilter=' + satisfactionFilter;

  if (query.startsWith('&'))
    query = query.replace('&', '?');

  return query;
}

function getDefaultState() {
  return {
    count: 0,
    data: [],
    questions: [],
    summary: {}
  };
}

const state = getDefaultState();

const actions = {
  reset({ commit }) {
    commit('mReset');
  },

  async getReportLink({commit, rootState, dispatch}, [dateFrom, dateTo, dateFilter, search, withAnswersOnly, satisfactionFilter]) {
    if (!rootState.user.token){
      await dispatch("user/reapplyToken", null, { root: true });
      if (!rootState.user.token)
        throw Error("Unable to download file without token");
    }

    commit;
    let query = SecKy.getUrlBase() + endpoint + '/download' + makeQuery(undefined, undefined, dateFrom, dateTo, dateFilter, search, withAnswersOnly, satisfactionFilter);
    

    query += "&access_token=" + rootState.user.token;
    return query;
  }, 
  async getQuestions({commit, rootState, dispatch}, cuid) {
    var result = await SecKy.get('/api/formQuestions/' + cuid);
    if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
        await dispatch("user/reapplyToken", null, { root: true });
        if (!rootState.user.token) {
            console.log(result.error);
            return;
        }
        result = await SecKy.get('/api/formQuestions/' + cuid);
    }
    
    if (result && result.ok) {
        console.log("Form questions successfully loaded")
        commit("mSetQuestions", result.payload.data);
        return;
    }
    
    console.error(result.error);
  },

  async getSurveys({ commit, rootState, dispatch }, [page, size, dateFrom, dateTo, dateFilter, search, withAnswersOnly, satisfactionFilter, tillEnd] ) {
    
    let query = endpoint + makeQuery(page, size, dateFrom, dateTo, dateFilter, search, withAnswersOnly, satisfactionFilter);
    
    var result = await SecKy.get(query);
    if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
        await dispatch("user/reapplyToken", null, { root: true });
        if (!rootState.user.token) {
            console.log(result.error);
            return;
        }
        result = await SecKy.get(query); 
    }

    console.log('load');
    if (tillEnd) {
      let i = 2;
      while (result.payload.count > result.payload.data.length) {
        const comms = await SecKy.get(endpoint + makeQuery(i, size, dateFrom, search, withAnswersOnly, satisfactionFilter));
        result.payload.data = result.payload.data.concat(comms.payload.data);
      }
    }

    console.log(result.payload);
    
    result.payload.data = result.payload.data.map(x => {
      x.reservation.reservationValues = x.reservation.reservationValues.map(y => {
        y.key = y.variable.variable;
        x[y.variable.variable] = y.value
        return y;
      })

      x.LOS = dateDiffInDays(x.reservation.arrivalDate, x.reservation.departureDate);
      return x;
    });

    let summaryQuery = endpoint + "/summary" + makeQuery(undefined, undefined, dateFrom, dateTo, dateFilter, search, withAnswersOnly, satisfactionFilter);
    
    let summaryResult = await SecKy.get(summaryQuery);
    console.log(summaryResult);
    result.payload.summary = summaryResult.payload.data;

    commit("mSet", result.payload);
  }
};


const mutations = {
  mReset(state) {
    Object.assign(state, getDefaultState());
  },
  mSetQuestions(state, payload) {
    state.questions = payload
  },
  mSet(state, payload) {
    console.log(state);

    state.count = payload.count;
    state.data = payload.data;
    state.summary = payload.summary;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

function dateDiffInDays(a, b) {
  if (typeof a === 'string')
    a = new Date(a); 
  if (typeof b === 'string')
    b = new Date(b); 
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}